var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgMobile = function SvgMobile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_12731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 2,
    width: 32,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 2H20a6 6 0 0 0-6 6v44a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6Z",
    fill: "url(#paint0_linear_264_12731)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_12731)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_12731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 2H20a6 6 0 0 0-6 6v44a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V8a6 6 0 0 0-6-6Z",
    fill: "url(#paint1_linear_264_12731)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_12731)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.51,
    cy: 62.097,
    rx: 11.234,
    ry: 10.463,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_264_12731)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.857,
    cy: 30.546,
    rx: 14.062,
    ry: 6.261,
    fill: "url(#paint2_linear_264_12731)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 2.25h20A5.75 5.75 0 0 1 45.75 8v44A5.75 5.75 0 0 1 40 57.75H20A5.75 5.75 0 0 1 14.25 52V8A5.75 5.75 0 0 1 20 2.25Z",
    stroke: "url(#paint3_linear_264_12731)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_264_12731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 52h10a1 1 0 1 0 0-2H25a1 1 0 1 0 0 2Z",
    fill: "#1F1C1B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_12731",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_12731",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_12731",
    x1: 28.119,
    y1: 22.23,
    x2: 11.884,
    y2: 24.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96EFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_12731",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 27.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_12731",
    x: 8,
    y: -4,
    width: 44,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_12731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_12731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_12731",
    x: 3.276,
    y: 25.634,
    width: 74.468,
    height: 72.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12731"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_264_12731",
    x: -12.361,
    y: 8.129,
    width: 60.435,
    height: 44.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.078,
    result: "effect1_foregroundBlur_264_12731"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_264_12731",
    x: 23,
    y: 49.5,
    width: 14,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_12731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_264_12731",
    result: "shape"
  })))));
};
export default SvgMobile;